import BrandsCont from 'elements/Brands/BrandsCont'
import React, { Component } from 'react'
import { Button, Col, message, Modal, Popconfirm, Row, Tabs } from 'antd'
import { execute, strVal } from '../../../../modules/Utils'
import _ from 'lodash'
import PersonalCont from '../Form/Profile/PersonalCont'
import ContactCont from '../Form/Profile/ContactCont'
import Representative from '../Form/Profile/Representative'
import Avatar from '../Avatar'
import DocumentsCont from '../../../Common/Documents/DocumentsCont'
import Members from '../../../../api/Members'
import { Tag } from 'antd'

const TabPane = Tabs.TabPane
const tagsColors = {
  Client: '#52fc4e',
  Government: '#3c53fc',
  Vendor: '#fcc43b',
  HR: '#fc5922',
  Corporate: '#fc8cfc',
  Lender: '#fc3428',
}
class Profile extends Component {
  constructor() {
    super()
    this.state = {
      formLayout: 'horizontal',
      updated: false,
      fetching: false,
    }
    this.api = new Members()
  }

  handleUpdated = () => {
    this.setState({ updated: true })
  }
  remove = async () => {
    const result = await execute(
      this,
      this.api.remove.bind(this, _.pick(this.props.member, ['_key', '_rev', '_id'])),
      message
    )
    if (result === true) this.props.handleCancel(true)
  }

  render() {
    const { visible, parent, handleCancel, member } = this.props

    const tags = member.tags || []
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    let footer = []
    if (parent === 'phonebook')
      footer.unshift(
        <Popconfirm title="Are you sure Remove this Contact?" onConfirm={this.remove} okText="Yes" cancelText="No">
          <Button loading={this.state.fetching} type="danger" style={{ marginLeft: 8 }}>
            Remove
          </Button>
        </Popconfirm>
      )
    return (
      <Modal
        title="PROFILE UPDATE"
        visible={visible}
        onCancel={() => {
          handleCancel(this.state.updated)
        }}
        width={'77%'}
        footer={footer}>
        <div>
          <Row>
            <Col xs={12} sm={6} md={6} style={{ textAlign: 'left' }}>
              <Avatar handleUpdated={this.handleUpdated} id={member._key} />
              <span style={{ marginLeft: 5 }}>ID: {member._key}</span>
            </Col>
            <Col xs={12} sm={6} md={6} style={{ paddingTop: '20px' }}>
              <p style={{ fontWeight: 'bold' }}>{member.fn}</p>
              <p style={{ fontStyle: 'italic' }}>{member.position}</p>
              <p>{strVal(member, 'email.label')}</p>
              <Row>
                {tags
                  .filter((t) => t !== null && t.status !== null)
                  .map((t) => (
                    <Tag color={t.status === 'Active' && tagsColors[t.name]}>{t.name}</Tag>
                  ))}
              </Row>
            </Col>
          </Row>
          <Row>
            <Tabs defaultActiveKey="1" size="small">
              <TabPane tab={member.kind === 'individual' ? 'Personal Details' : 'Company Details'} key="1">
                <div>
                  <PersonalCont handleUpdated={this.handleUpdated} member={member} formItemLayout={formItemLayout} />
                </div>
              </TabPane>

              <TabPane tab={'Brands'} key="brands">
                <div>
                  <BrandsCont owner={member._key} />
                </div>
              </TabPane>
              <TabPane tab="Contact Details" key="2">
                <div>
                  <ContactCont handleUpdated={this.handleUpdated} member={member} formItemLayout={formItemLayout} />
                </div>
              </TabPane>
              <TabPane tab="Address Details" key="3">
                <div>
                  <ContactCont
                    handleUpdated={this.handleUpdated}
                    member={member}
                    formItemLayout={formItemLayout}
                    type={'address'}
                  />
                </div>
              </TabPane>
              <TabPane tab={member.kind === 'individual' ? 'Representing Organisations' : 'Representative'} key="4">
                <div>
                  <Representative handleUpdated={this.handleUpdated} member={member} />
                </div>
              </TabPane>
              <TabPane tab="Documents" key="5">
                {/*<DocumentsCont handleUpdated={this.handleUpdated} member={member}/>*/}
                <DocumentsCont editable={false} owner={member} />
              </TabPane>
            </Tabs>
          </Row>
        </div>
      </Modal>
    )
  }
}
Profile.defaultProps = {
  member: { tags: [] },
}

export default Profile
